import { Alert } from 'antd'
import hoistStatics from 'hoist-non-react-statics'
import React from 'react'
import { connect } from 'react-redux'
import { firebaseConnect, isEmpty, isLoaded } from 'react-redux-firebase'
import { compose } from 'redux'
import { hasRole } from '../../helpers/auth'
import { wrapDisplayName } from './utils'

const authorize = (role, WrappedComponent, provider) => {
  class Authenticate extends React.Component<any, any> {
    static wrappedComponent = WrappedComponent
    static displayName = wrapDisplayName(WrappedComponent, 'Authenticate')

    constructor(props) {
      super(props)
      this.state = { loginRequested: false }
    }

    componentWillReceiveProps(newProps) {
      const { firebase, auth } = newProps
      if (isLoaded(auth) && isEmpty(auth) && !this.state.loginRequested) {
        this.setState({ loginRequested: true })
        firebase.login({ provider, type: 'redirect' })
      }
    }

    render() {
      const { auth, profile } = this.props
      if (isEmpty(auth) || !isLoaded(profile)) {
        return <span>Loading profile...</span>
      } else if (hasRole(role, 'ag', profile)) {
        // TODO: tenant cannot be hardcoded here!
        return <WrappedComponent {...this.props} />
      } else {
        return (
          <Alert
            message="Insufficient Permissions"
            description="You do not have permissions to access these records."
            type="warning"
            showIcon
          />
        )
      }
    }
  }

  return hoistStatics(Authenticate, WrappedComponent)
}

export default (role, provider = 'google') => (WrappedComponent) =>
  compose<any>(
    firebaseConnect(),
    connect(({ firebase: { auth, profile } }: FIXME) => ({ auth, profile })),
  )(authorize(role, WrappedComponent, provider))



// WEBPACK FOOTER //
// ./src/components/higher-order/authorize.tsx